export const loadingConfig = {
  GetPageLoading: {
    image: 'https://i.ibb.co/CbVc1f2/Ministry-New-Logo-cropped-PNG-1.png',
    titleNormalText: 'Loading',
    titleBoldText: '...',
    description: 'This might take few seconds, Please wait !',
  },
  registerUser: {
    image: 'https://i.ibb.co/CbVc1f2/Ministry-New-Logo-cropped-PNG-1.png',
    titleNormalText: 'Registering',
    titleBoldText: 'your account...',
    description: 'This might take few seconds, Please wait !',
  },
};
